module.exports = __webpack_public_path__ + "img/table_chart.d46f52ef.svg";